module.exports = __webpack_public_path__ + "static/media/recreate.e1740be2.svg";